export default "__VITE_ASSET__pwnimktp__"